/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
export function abs(params) {
  return Math.abs(params[0]);
}

export default buildHelper(abs);
